import { getLicenseRole } from './licenseHelper';
import { ROLE_EXTERNAL_DEALER } from '../config/appConstants';
import { ROUTES } from '../config/routes';
import { evaluateRouteAccess } from './rbacGuard';

// IMP-483 — 로그인 화면 통합(/Login, /Admin/Login) 랜딩 판정 SSoT.
// AdminLogin.js 의 resolveAdminLandingPath / resolvePostLoginPath 를 동작 변경 없이 이전.
//
// Truth table:
//   외부 딜러(ExternalDealer)                     → /Admin/License (permAdminAccess 값과 무관, 최우선)
//   permAdminAccess=true (non-Dealer)             → /Admin/Dashboard
//   그 외 (InternalDealer·HQ·Subsidiary 등)        → /Home
// 역할 판별은 getLicenseRole SSoT 함수를 사용하여 dealerType raw 비교를 제거.
export const resolveLandingPath = (user) => {
    if (getLicenseRole(user) === ROLE_EXTERNAL_DEALER) return ROUTES.ADMIN_LICENSE;
    if (user?.permAdminAccess) return ROUTES.ADMIN_DASHBOARD;
    return ROUTES.HOME;
};

// BUG fix: 미로그인 상태로 보호 경로 직접 진입 → 로그인 후 원래 경로로 복귀.
// AuthRoute 가 Redirect state.from 에 원 경로를 실어 보내므로, 로그인 직후 그 경로를 우선 사용한다.
// from 이 없거나 안전하지 않으면(외부 URL / protocol-relative / 로그인 경로 루프) 권한 기반 랜딩으로 폴백.
//
// 왕복(bounce) 방지: 위 안전성 검사를 통과해도 그 사용자가 실제로 접근 가능한 경로인지는
// 별개 문제다. Admin Access 가 없는 계정이 로그아웃 전 보던 /Admin/* 화면으로 복귀했다가
// AuthRoute 가드에 의해 다시 /Home 으로 튕기는 왕복을 막기 위해, rbacGuard.js SSoT
// evaluateRouteAccess() 로 접근 가능 여부를 판정한 뒤에만 복귀 경로를 사용한다.
const LOGIN_PATHS = [ROUTES.LOGIN, ROUTES.ADMIN_LOGIN].map((p) => p.toLowerCase());
export const resolvePostLoginPath = (user, fromPath) => {
    if (
        typeof fromPath === 'string' &&
        fromPath.startsWith('/') &&            // 내부 절대경로만 (open-redirect 방지)
        !fromPath.startsWith('//') &&          // protocol-relative 차단
        !LOGIN_PATHS.includes(fromPath.split('?')[0].toLowerCase())  // 로그인 경로 루프 방지
    ) {
        const decision = evaluateRouteAccess({
            role: getLicenseRole(user),
            permAdminAccess: !!user?.permAdminAccess,
            pathname: fromPath,
        });
        if (decision.allow) return fromPath;
    }
    return resolveLandingPath(user);
};

// iubenda(개인정보 처리방침) 동의 필요 여부. 동의 완료(isIubenda=true)가 아니면 true.
export const needsIubendaConsent = (user) => !(user?.isIubenda);
